import React from "react";
import { Outlet } from "react-router-dom";
import ComplianceMasterTabs from "./ComplianceMasterTabs";

const ComplianceMaster = () => {
    return (
        <div className="container-fluid">
            <ComplianceMasterTabs />

            <div className="mt-3">
                <Outlet />
            </div>
        </div>
    );
};

export default ComplianceMaster;